import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, InputBase } from '@mui/material';
import Moment from 'react-moment';
import { AiOutlineSearch } from 'react-icons/ai';
import CustomNoRowsOverlay from '../../PageComponent/PlaceholderDatatable';
import CustomPagination from './Custompagination';


function CreditUsageDataGrid({ data }) {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const pageSize = 10;

    // Whenever data or search changes, reset page to 0
    useEffect(() => {
        setPage(0);
    }, [search, data]);
    console.log("data", data)
    // Prepare rows by flattening fields from data (like DoctorName[0])
    const preparedRows = data?.map((item, index) => ({
        id: item._id || index,
        doctorName: item.DoctorName?.[0] || '',
        specialization: item.Specalaization?.[0] || '',
        type: item.ConsultationType?.[0] || '',
        completedDate: item.CompletedDate?.[0] || '',
        payment: Number(item?.AmountPaid) || 0,
        status: item.status || '',
    }));

    // Filter rows by search (case-insensitive substring match in any field)
    const filteredRows = preparedRows?.filter((row) =>
        Object.values(row).some((val) =>
            String(val).toLowerCase().includes(search.toLowerCase())
        )
    );

    // Paginate filtered rows
    const paginatedRows = filteredRows?.slice(page * pageSize, (page + 1) * pageSize);
    const totalPages = Math.ceil(filteredRows?.length / pageSize);

    const columns = [
        { field: 'doctorName', headerName: 'Doctor Name', flex: 1, minWidth: 150 },
        { field: 'specialization', headerName: 'Specialization', flex: 1, minWidth: 150 },
        { field: 'type', headerName: 'Type', flex: 1, minWidth: 120 ,  
          renderCell: (params) => (
            <p className="capitalize">{params.value}</p>
           ),
        },
        {
            field: 'completedDate',
            headerName: 'Completed Date',
            flex: 1,
            minWidth: 180,
            renderCell: (params) =>
                params.value ? <Moment format="YYYY-MM-DD">{params.value}</Moment> : '—',
        },
        {
            field: 'payment',
            headerName: 'Payment',
            minWidth: 180,
            flex: 1,

        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 120,
            renderCell: (params) =>
                params.value.charAt(0).toUpperCase() + params.value.slice(1),
        },
    ];

    return (
        <Box p={2} sx={{ width: '100%' }}>
            {/* Search bar */}
            <div className="flex justify-between items-center px-4 py-2 bg-[#f3f8ff] rounded-t-lg mb-2">
                <div className="ml-auto w-[300px] flex items-center gap-2 border border-slate-300 rounded px-2 py-1 bg-white">
                    <AiOutlineSearch className="text-slate-500" />
                    <InputBase
                        placeholder="Search"
                        className="text-sm"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            <DataGrid
                rows={paginatedRows}
                columns={columns}
                autoHeight
                disableColumnMenu
                disableRowSelectionOnClick
                disableColumnSorting
                hideFooter
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                sx={{
  fontFamily: 'var(--font-family)',
  '--DataGrid-overlayHeight': '80px',
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell--withRenderer': {
    padding: '8px',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#fff',
    borderBottom: '1px solid #e2e8f0',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
    textAlign: 'left',
  },

  // 🎯 MODERN SCROLLBAR for the virtual scroller
   '& .MuiDataGrid-virtualScroller': {
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
        borderRadius: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '10px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#555',
      },
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    },
}}


            />


            <CustomPagination page={page} totalPages={totalPages} setPage={setPage} />
        </Box>
    );
}

export default CreditUsageDataGrid;
